<script setup lang="ts">
import { onMounted, watch } from 'vue'

import EmbedContentLoader from './EmbedContentLoader.vue'

declare global {
  interface Window {
    twttr: {
      widgets: {
        load: () => void
      }
      _e: Array<() => void>;
      ready: (f: () => void) => void;
    };
  }
}

const props = defineProps({
  html: {
    type: String,
    required: true
  }
})

function triggerEmbedScript () {
  if (typeof window !== 'undefined') {
    if (window.twttr && window.twttr.widgets && typeof window.twttr.widgets.load === 'function') {
      window.twttr.widgets.load()
    } else {
      const twitterScriptUrl = 'https://platform.twitter.com/widgets.js'
      window.twttr = (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0]
        const t = window.twttr || {}
        if (d.getElementById(id)) return t
        const js = d.createElement(s) as HTMLScriptElement
        js.id = id
        js.src = twitterScriptUrl
        if (fjs.parentNode) {
          fjs.parentNode.insertBefore(js, fjs)
        }

        t._e = []
        t.ready = function (f: () => void) {
          t._e.push(f)
        }
        return t
      }(document, 'script', 'twitter-wjs'))
    }
  }
}

onMounted(() => {
  triggerEmbedScript()
})

watch(() => props.html, () => {
  triggerEmbedScript()
})
</script>

<template>
  <EmbedContentLoader class="min-h-[225px]"
                      :html="props.html"
                      @script-loaded="triggerEmbedScript()" />
</template>
